import { NavLink } from 'react-router-dom';
import { cn } from 'lib/cn';
import { ROUTES } from 'lib/constants';
import { Brand } from 'components/ui';
import {
  HomeIcon,
  BoxIcon,
  ReceiptIcon,
  CartIcon,
  AdjustIcon,
  WalletIcon,
  StoreIcon,
  UsersIcon,
  CreditCardIcon,
} from 'components/icons';

const NAV_SECTIONS = [
  {
    items: [
      { to: ROUTES.DASHBOARD, label: 'Dashboard', icon: HomeIcon, end: true },
      { to: ROUTES.CATALOG, label: 'Catalog', icon: BoxIcon },
      { to: ROUTES.ORDERS, label: 'Orders', icon: ReceiptIcon },
      { to: ROUTES.INSTORE_SALE, label: 'Record sale', icon: CartIcon },
      { to: ROUTES.INVENTORY, label: 'Stock adjustment', icon: AdjustIcon },
      { to: ROUTES.EARNINGS, label: 'Earnings', icon: WalletIcon },
    ],
  },
  {
    title: 'Settings',
    items: [
      { to: ROUTES.SHOP, label: 'Shop', icon: StoreIcon },
      { to: ROUTES.STAFF, label: 'Staff', icon: UsersIcon },
      { to: ROUTES.BANK, label: 'Bank accounts', icon: CreditCardIcon },
    ],
  },
];

/** Navigation rail. Reused by both the desktop sidebar and the mobile drawer. */
export function Sidebar({ profile, onNavigate }) {
  return (
    <div className="flex h-full flex-col">
      <div className="flex items-center gap-3 px-5 py-5">
        <Brand size="sm" className="shrink-0" />
        <div className="min-w-0">
          <p className="truncate text-sm font-semibold text-slate-900">
            {profile?.businessName || 'Quro Vendor'}
          </p>
          <p className="truncate text-xs text-slate-500">{profile?.city || 'Vendor dashboard'}</p>
        </div>
      </div>

      <nav className="flex-1 space-y-4 overflow-y-auto px-3 pb-4">
        {NAV_SECTIONS.map((section, index) => (
          <div key={section.title || index} className="space-y-1">
            {section.title && (
              <p className="px-3 pb-1 pt-2 text-xs font-semibold uppercase tracking-wide text-slate-400">
                {section.title}
              </p>
            )}
            {section.items.map(({ to, label, icon: Icon, end }) => (
              <NavLink
                key={to}
                to={to}
                end={end}
                onClick={onNavigate}
                className={({ isActive }) =>
                  cn(
                    'flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium transition',
                    isActive
                      ? 'bg-brand-50 text-brand-700'
                      : 'text-slate-600 hover:bg-surface-100 hover:text-slate-900',
                  )
                }
              >
                <Icon className="h-5 w-5" />
                {label}
              </NavLink>
            ))}
          </div>
        ))}
      </nav>

      <p className="px-5 py-4 text-xs text-slate-400">Quro Vendor · v0.1</p>
    </div>
  );
}

export default Sidebar;
